export default __webpack_public_path__ + "static/media/growth-notes-logo3x.bcaf38c2.png";